/* ms-ring.js - 3D-Kollektionsring, herausgeloest aus assets/ms-apparel.js (17.09.2026).
   Wird von der Bekleidungsseite und kuenftig von einer Challenge-Section genutzt.
   Einziges Global: window.MSRing mit MSRing.create(opts) -> api oder null.

   Echter Ring (preserve-3d): jede Karte rotateY + translateZ, zum Rand ueber den Winkel
   ausgeblendet, links und rechts spiegelgleich. Klick: anhalten, zur Mitte drehen und nach
   vorn (Groesse ueber die Perspektive), die anderen dunkeln ab. Dann fliegt das Bild an seinen
   Platz im Pop-up und die Karte oeffnet sich aus dem Bild; Schliessen genau umgekehrt: die Karte
   faehrt ins Bild zurueck, das Bild fliegt zur Ringkarte, die in den Ring zurueckgleitet.
   Der Bildflug ist eine Kopie im Seitenverhaeltnis des Fotos: Lage per transform (gleichmaessige
   Skala), sichtbarer Ausschnitt per clip-path, wie object-fit: cover, das Foto verzerrt nie.

   opts:
     coll          Wurzelelement der Kollektion (Bezugsrahmen fuer Ghost und Pop-up)
     stage         Buehne mit der Perspektive, faengt die Zeigerereignisse
     ring          Ringtraeger (preserve-3d), bekommt die Karten
     pop           Pop-up-Element (hidden), mit .<cls>-rpop__card, __bg, __x, __info und den
                   Datenattributen data-<cls>-rimg, -rt, -rp, -rf, -rlink, -rclose
     items         Array von Kartendaten; Standardform {t, ph, img, url, type, colors, w, h}
                   (w/h optional: Bildmasse fuer width/height am img und damit fuers Ghost)
     labels        {open, factType, factColors, factPrice} fuer aria-label und Pop-up-Fakten
     phone         () => boolean, mobiles Layout (Vorgabe window.innerWidth < 750)
     headerOffset  () => number, Hoehe des fixen Kopfs in px (Vorgabe: --header-height oder 84)
     autoplay      boolean, Ring dreht von selbst (Vorgabe true)
     cls           Klassenpraefix fuer Karten, Ghost, Pop-up und Datenattribute (Vorgabe 'ap')
     cardHtml      optional, (item, i) => innerHTML der Karte statt der Standardform
     fillPop       optional, (item, pop) => void fuellt das Pop-up statt der Standardform
     pack          optional, dicht gepackter Ring (Runde 44, Challenge-Seite): { gap, desktop: {...},
                   phone: {...} }. desktop/phone ueberschreiben die Masse (w = Kartenbreite wie im CSS,
                   shift, persp, maxA, fwd, k, rad). Die Kartenzahl ergibt sich einmalig aus
                   2*pi*R / (w + gap); R wird danach je Layout so gerechnet, dass die Karten mit genau
                   gap Abstand stehen. Ohne pack bleibt alles wie bisher (16 Karten, feste Masse).

   api: destroy(), open(i), close(), rotateTo(i) */
(function () {
  'use strict';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  /* Bewegungsreduktion live lesen: der Nutzer kann sie waehrend der Sitzung umschalten */
  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)', SPRING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function create(opts) {
    opts = opts || {};
    var coll = opts.coll, stage = opts.stage, rc = opts.ring, pop = opts.pop;
    var ITEMS = opts.items || [];
    if (!coll || !stage || !rc || !pop || !ITEMS.length) return null;
    var cls = opts.cls || 'ap', L = opts.labels || {};
    var autoplay = opts.autoplay !== false;
    var phone = typeof opts.phone === 'function' ? opts.phone : function () { return window.innerWidth < 750; };
    var headerOffset = typeof opts.headerOffset === 'function' ? opts.headerOffset : function () { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 84; };
    var q = function (s, el) { return (el || coll).querySelector(s); };
    var qa = function (s, el) { return Array.prototype.slice.call((el || coll).querySelectorAll(s)); };
    var C = function (n) { return cls + '-' + n; };
    var A = function (n) { return '[data-' + cls + '-' + n + ']'; };

    var PD = { R: 900, shift: 410, k: 0.1, maxA: 58, fwd: 470, persp: 400, rad: 14 };
    /* Mobil groesser (Vorgabe Fabian 15.09.2026): Mittelkarte ca. 45 % der Breite, Nachbarn angeschnitten */
    var PM = { R: 600, shift: 470, k: 0.16, maxA: 40, fwd: 150, persp: 420, rad: 12 };
    var pack = opts.pack || null;
    var over = function (base, add) { var o = {}, k; for (k in base) o[k] = base[k]; for (k in (add || {})) o[k] = add[k]; return o; };
    if (pack) { PD = over(PD, pack.desktop); PM = over(PM, pack.phone); }
    var P = PD, S0 = 1, S1 = 1, N = 16;
    if (pack) { var P0 = phone() ? PM : PD; N = Math.max(10, Math.round(2 * Math.PI * P0.R / (P0.w + (pack.gap || 8)))); }
    var STEP = 360 / N, cards = [];
    var rot = 0, vel = 0, drag = false, lastX = 0, moved = 0, mode = 'run', active = null, dimF = 1, tweens = [];
    var dead = false, raf = 0, io = null;

    var cardHtml = typeof opts.cardHtml === 'function' ? opts.cardHtml : function (it) {
      var dim = it.w && it.h ? ' width="' + parseInt(it.w, 10) + '" height="' + parseInt(it.h, 10) + '"' : '';
      return (it.img ? '<img src="' + esc(it.img) + '" alt=""' + dim + ' loading="lazy" draggable="false">' : '<span class="' + C('rcard__ph') + '"></span>') +
        '<span class="' + C('rcard__cap') + '"><b>' + esc(it.t) + '</b><span>' + esc(it.ph) + '</span></span>';
    };
    var fillPop = typeof opts.fillPop === 'function' ? opts.fillPop : function (it) {
      q(A('rimg'), pop).innerHTML = it.img ? '<img src="' + esc(it.img) + '" alt="">' : '';
      q(A('rt'), pop).textContent = it.t; q(A('rp'), pop).textContent = it.ph;
      var facts = [];
      if (it.type) facts.push([L.factType, it.type]);
      if (it.colors) facts.push([L.factColors, it.colors]);
      facts.push([L.factPrice, it.ph]);
      q(A('rf'), pop).innerHTML = facts.map(function (x) { return '<dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd>'; }).join('');
      var link = q(A('rlink'), pop); if (link) link.href = it.url || '#';
    };

    for (var i = 0; i < N; i++) {
      var it = ITEMS[i % ITEMS.length], el = document.createElement('button');
      el.type = 'button'; el.className = C('rcard');
      el.setAttribute('aria-label', it.t + ', ' + it.ph + ', ' + (L.open || ''));
      /* Wiederholungen zum Auffuellen des Rings: Screenreader und Tab-Reihe hoeren jeden Eintrag nur einmal */
      if (i >= ITEMS.length) { el.tabIndex = -1; el.setAttribute('aria-hidden', 'true'); }
      el.innerHTML = cardHtml(it, i);
      cards.push({ it: it, el: el, z: 0, vis: null, hide: false, t: '', o: '' });
      (function (idx) { el.addEventListener('click', function (e) { if (e.detail === 0) openCard(idx); }); })(i);
      rc.appendChild(el);
    }
    var norm = function (a) { return ((a % 360) + 540) % 360 - 180; };
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var easeOutCubic = function (x) { return 1 - Math.pow(1 - x, 3); };
    var easeInOutSine = function (x) { return -(Math.cos(Math.PI * x) - 1) / 2; };
    var bez = function (x1, y1, x2, y2) {
      return function (t) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        var lo = 0, hi = 1, s = t;
        for (var j = 0; j < 20; j++) { var u = 1 - s, x = 3 * u * u * s * x1 + 3 * u * s * s * x2 + s * s * s; if (x < t) lo = s; else hi = s; s = (lo + hi) / 2; }
        var v = 1 - s;
        return 3 * v * v * s * y1 + 3 * v * s * s * y2 + s * s * s;
      };
    };
    var flyEase = bez(0.22, 1, 0.36, 1);
    var dur = function (ms) { return reduce() ? 1 : ms; };
    var tweenRaw = function (set, ms, done) { tweens.push({ set: set, t0: performance.now(), dur: Math.max(1, ms), done: done }); };
    var runTweens = function (t) { var list = tweens; tweens = []; list.forEach(function (tw) { var k = Math.min(1, Math.max(0, (t - tw.t0) / tw.dur)); tw.set(k); if (k < 1) tweens.push(tw); else if (tw.done) tw.done(); }); };
    /* Nach vorn wird die sichtbare Groesse animiert, nicht die Tiefe: linear in Z waechst die Karte
       durch die Perspektive am Ende schlagartig. */
    var scaleAt = function (z) { return P.persp / (P.persp - (P.shift - P.R + z)); };
    var zForScale = function (s) { return (P.persp - P.persp / s) - (P.shift - P.R); };
    var setup = function () {
      P = phone() ? PM : PD;
      /* Dicht gepackt: Radius aus Kartenzahl und Kartenbreite, damit der Abstand genau gap ist */
      if (pack && P.w) P.R = N * (P.w + (pack.gap || 8)) / (2 * Math.PI);
      stage.style.perspective = P.persp + 'px';
      rc.style.transform = 'translateZ(' + P.shift + 'px)';
      S0 = scaleAt(0); S1 = scaleAt(P.fwd);
      cards.forEach(function (c) { c.t = ''; c.z = 0; });
    };
    setup();

    function layout() {
      cards.forEach(function (c, idx) {
        var a = norm(idx * STEP + rot), abs = Math.abs(a);
        if (abs > P.maxA + 4) { if (c.vis !== false) { c.el.style.visibility = 'hidden'; c.vis = false; } return; }
        if (c.vis !== true) { c.el.style.visibility = 'visible'; c.vis = true; }
        var tf = 'rotateY(' + a.toFixed(2) + 'deg) translateZ(' + (-P.R + c.z).toFixed(1) + 'px)';
        if (tf !== c.t) { c.el.style.transform = tf; c.t = tf; }
        var op = Math.max(0, Math.min(1, (P.maxA + 4 - abs) / 10));
        if (active && c !== active) op *= dimF;
        if (c.hide) op = 0;
        var os = op >= 0.999 ? '' : op.toFixed(3);
        if (os !== c.o) { c.el.style.opacity = os; c.o = os; }
      });
    }
    var onStage = false;
    if ('IntersectionObserver' in window) { io = new IntersectionObserver(function (es) { onStage = es.some(function (e) { return e.isIntersecting; }); }, { threshold: 0 }); io.observe(stage); } else onStage = true;
    var lastT = 0;
    function tick(t) {
      /* Schleife endet, sobald die Kollektion aus dem DOM faellt oder destroy() lief */
      if (dead || !coll.isConnected) { raf = 0; return; }
      var dt = lastT ? Math.min(64, t - lastT) : 16.7, f = dt / 16.7;
      lastT = t;
      if (onStage || tweens.length) {
        runTweens(t);
        if (mode === 'run' && !drag) { vel *= Math.pow(0.94, f); rot += ((autoplay && !reduce()) ? -0.035 * f : 0) + vel * f; }
        layout();
      }
      raf = requestAnimationFrame(tick);
    }

    var rectN = function (el) { var r = el.getBoundingClientRect(), b = coll.getBoundingClientRect(); return { x: r.left - b.left, y: r.top - b.top, w: r.width, h: r.height }; };
    var imgBox = function (c) { return rectN(c.el.querySelector('img, .' + C('rcard__ph')) || c.el); };
    var lerpBox = function (a, b, k) { return { x: a.x + (b.x - a.x) * k, y: a.y + (b.y - a.y) * k, w: a.w + (b.w - a.w) * k, h: a.h + (b.h - a.h) * k }; };
    var insetOf = function (inner, outer, r) { return 'inset(' + (inner.y - outer.y).toFixed(1) + 'px ' + (outer.x + outer.w - inner.x - inner.w).toFixed(1) + 'px ' + (outer.y + outer.h - inner.y - inner.h).toFixed(1) + 'px ' + (inner.x - outer.x).toFixed(1) + 'px round ' + r + 'px)'; };
    var makeGhost = function (c) {
      var im = c.el.querySelector('img'), g = document.createElement('div'), W0 = 640;
      /* Seitenverhaeltnis aus den width/height-Attributen, weil das Bild (lazy) noch nicht geladen
         sein kann; naturalWidth nur als Rueckfall, sonst quadratisch */
      var aw = im ? parseFloat(im.getAttribute('width')) : 0, ah = im ? parseFloat(im.getAttribute('height')) : 0;
      if (!(aw > 0 && ah > 0) && im && im.naturalWidth) { aw = im.naturalWidth; ah = im.naturalHeight; }
      var H0 = aw > 0 && ah > 0 ? Math.round(W0 * ah / aw) : W0;
      g.className = C('rghost');
      g.innerHTML = c.it.img ? '<img src="' + esc(c.it.img) + '" alt="">' : '';
      g.style.width = W0 + 'px'; g.style.height = H0 + 'px';
      g._w = W0; g._h = H0;
      coll.appendChild(g);
      return g;
    };
    /* Kopie so legen, dass genau box sichtbar ist: Skala wie object-fit cover, Rest per clip-path weg */
    var ghostAt = function (g, box, rad) {
      var s = Math.max(box.w / g._w, box.h / g._h), ix = (g._w - box.w / s) / 2, iy = (g._h - box.h / s) / 2;
      var tx = box.x + box.w / 2 - g._w / 2, ty = box.y + box.h / 2 - g._h / 2;
      var cp = 'inset(' + iy.toFixed(2) + 'px ' + ix.toFixed(2) + 'px round ' + (rad / s).toFixed(2) + 'px)';
      g.style.transform = 'translate3d(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px, 0) scale(' + s.toFixed(4) + ')';
      g.style.clipPath = cp; g.style.webkitClipPath = cp;
    };
    var popParts = function () { return qa('.' + C('rpop__info') + ' > *, .' + C('rpop__x'), pop); };

    function openCard(idx) {
      if (mode !== 'run') return;
      var c = cards[idx], a = norm(idx * STEP + rot), r0 = rot;
      active = c; mode = 'turn'; vel = 0;
      /* Eine durchgehende Bewegung: Drehen klingt aus, waehrend die Karte schon nach vorn kommt */
      tweenRaw(function (u) {
        rot = r0 - a * easeOutCubic(Math.min(1, u / 0.62));
        var f = easeInOutSine(Math.max(0, (u - 0.28) / 0.72));
        c.z = zForScale(S0 + (S1 - S0) * f);
        dimF = 1 - 0.82 * f;
      }, dur(Math.min(1250, 780 + Math.abs(a) * 8)), function () { mode = 'open'; showPop(); });
    }
    function showPop() {
      var c = active, it = c.it;
      fillPop(it, pop);
      pop.hidden = false;
      var panel = q('.' + C('rpop__card'), pop), img = q(A('rimg'), pop), bg = q('.' + C('rpop__bg'), pop), x = q('.' + C('rpop__x'), pop);
      if (phone()) { var cr = coll.getBoundingClientRect(); pop.style.paddingTop = Math.max(10, Math.round(-cr.top + headerOffset() + 12)) + 'px'; }
      if (reduce() || !panel.animate) { if (x) x.focus({ preventScroll: true }); return; }
      var from = imgBox(c), to = rectN(img), pr = rectN(panel), g = makeGhost(c);
      ghostAt(g, from, P.rad);
      c.hide = true; layout();
      panel.style.visibility = 'hidden';
      bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 520, easing: 'ease-out' });
      /* 1. Das Bild fliegt an seinen Platz im Pop-up */
      tweenRaw(function (u) { ghostAt(g, lerpBox(from, to, flyEase(u)), P.rad); }, 560, function () {
        /* 2. Die Karte oeffnet sich aus dem Bild heraus */
        panel.style.visibility = ''; panel.style.boxShadow = 'none';
        var open = panel.animate([{ clipPath: insetOf(to, pr, P.rad) }, { clipPath: 'inset(0px 0px 0px 0px round 22px)' }], { duration: 520, easing: SPRING });
        requestAnimationFrame(function () { g.remove(); });
        popParts().forEach(function (e, n) { e.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 440, delay: 140 + n * 40, easing: EASE_OUT, fill: 'backwards' }); });
        open.onfinish = function () { panel.style.transition = 'box-shadow 420ms ease'; panel.style.boxShadow = ''; setTimeout(function () { panel.style.transition = ''; }, 460); };
        if (x) x.focus({ preventScroll: true });
      });
    }
    function closeCard() {
      if (mode !== 'open') return;
      mode = 'closing';
      var c = active, bg = q('.' + C('rpop__bg'), pop), panel = q('.' + C('rpop__card'), pop), img = q(A('rimg'), pop);
      var done = function () {
        pop.hidden = true;
        panel.style.visibility = ''; panel.style.boxShadow = ''; panel.style.transition = '';
        panel.getAnimations().forEach(function (x) { x.cancel(); });
        bg.getAnimations().forEach(function (x) { x.cancel(); });
        popParts().forEach(function (e) { e.getAnimations().forEach(function (x) { x.cancel(); }); });
      };
      if (reduce() || !panel.animate) {
        done(); c.hide = false;
        tweenRaw(function (u) { c.z = zForScale(S1 + (S0 - S1) * u); dimF = 0.18 + 0.82 * u; }, dur(640), function () { active = null; dimF = 1; mode = 'run'; });
        return;
      }
      var from = rectN(img), pr = rectN(panel);
      popParts().forEach(function (e) { e.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-in', fill: 'forwards' }); });
      panel.style.transition = ''; panel.style.boxShadow = 'none';
      /* 1. Die Karte faehrt zurueck ins Bild */
      var shrink = panel.animate([{ clipPath: 'inset(0px 0px 0px 0px round 22px)' }, { clipPath: insetOf(from, pr, P.rad) }], { duration: 380, delay: 60, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' });
      shrink.onfinish = function () {
        /* 2. Das Bild fliegt zur Ringkarte, die in derselben Bewegung in den Ring zurueckgleitet */
        var g = makeGhost(c);
        ghostAt(g, from, P.rad);
        panel.style.visibility = 'hidden';
        bg.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 700, easing: 'ease-in-out', fill: 'forwards' });
        tweenRaw(function (u) {
          var e = ease(u);
          c.z = zForScale(S1 + (S0 - S1) * e);
          dimF = 0.18 + 0.82 * e;
          layout();
          ghostAt(g, lerpBox(from, imgBox(c), e), P.rad);
        }, dur(720), function () {
          c.hide = false; layout();
          /* Kopie erst entfernen, wenn die Karte darunter gemalt ist, kein Aufblitzen beim Einsortieren */
          requestAnimationFrame(function () { requestAnimationFrame(function () { g.remove(); }); });
          done(); active = null; dimF = 1; mode = 'run'; c.el.focus({ preventScroll: true });
        });
      };
    }
    /* Ring nur drehen, bis Karte i vorn steht (ohne Pop-up), gleiche Kurve wie beim Oeffnen */
    function rotateTo(idx) {
      if (mode !== 'run' || !cards[idx]) return;
      var a = norm(idx * STEP + rot), r0 = rot;
      vel = 0;
      tweenRaw(function (u) { rot = r0 - a * easeOutCubic(u); }, dur(Math.min(1250, 500 + Math.abs(a) * 8)));
    }

    var onPopClick = function (e) { if (e.target.closest(A('rclose'))) closeCard(); };
    var onKey = function (e) { if (e.key === 'Escape') closeCard(); };
    var onDown = function (e) {
      if (mode !== 'run' || e.button > 0) return;
      drag = true; lastX = e.clientX; moved = 0; vel = 0;
      stage.classList.add('is-drag');
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    };
    var onMove = function (e) { if (!drag) return; var dx = e.clientX - lastX; lastX = e.clientX; moved += Math.abs(dx); rot += dx * P.k; vel = dx * P.k; };
    var end = function (e) {
      if (!drag) return;
      drag = false; stage.classList.remove('is-drag');
      if (e.type !== 'pointerup' || moved >= 6) return;
      vel = 0;
      /* Treffer selbst bestimmen: Chrome meldet bei Karten hinter der Buehnenebene die Buehne statt
         der Karte. Unter allen sichtbaren Karten, deren Rechteck den Punkt enthaelt, gewinnt die,
         deren Mitte am naechsten liegt. */
      var bestI = -1, bestD = Infinity;
      cards.forEach(function (c, idx) {
        if (c.vis !== true || (c.o !== '' && parseFloat(c.o) < 0.5)) return;
        var r = c.el.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2), d = dx * dx + dy * dy;
        if (d < bestD) { bestD = d; bestI = idx; }
      });
      if (bestI >= 0) openCard(bestI);
    };
    var onResize = function () { if (mode === 'run' && (phone() ? PM : PD) !== P) setup(); };
    pop.addEventListener('click', onPopClick);
    document.addEventListener('keydown', onKey);
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    window.addEventListener('resize', onResize);
    layout(); raf = requestAnimationFrame(tick);

    function destroy() {
      if (dead) return;
      dead = true;
      if (raf) cancelAnimationFrame(raf); raf = 0;
      tweens = [];
      if (io) io.disconnect();
      pop.removeEventListener('click', onPopClick);
      document.removeEventListener('keydown', onKey);
      stage.removeEventListener('pointerdown', onDown);
      stage.removeEventListener('pointermove', onMove);
      stage.removeEventListener('pointerup', end); stage.removeEventListener('pointercancel', end);
      window.removeEventListener('resize', onResize);
      qa('.' + C('rghost')).forEach(function (g) { g.remove(); });
      cards.forEach(function (c) { c.el.remove(); });
      cards = [];
    }

    return {
      destroy: destroy,
      open: function (idx) { if (cards[idx]) openCard(idx); },
      close: closeCard,
      rotateTo: rotateTo
    };
  }

  window.MSRing = { create: create };
})();
